import startCase from 'lodash/startCase';

var _characterClasses = [];
var _characterClassSkins = [];
var _heroes = [];
var _equipments = [];
var _consumables = [];
var _dices = [];

export const fields = (characterClasses, characterClassSkins, heroes, equipments, consumables, dices) => {
    _characterClasses = _characterClasses.length === 0 ? transformArr(characterClasses) : _characterClasses;
    _characterClassSkins = _characterClassSkins.length === 0 ? transformArr(characterClassSkins) : _characterClassSkins;
    _heroes = _heroes.length === 0 ? transformArr(heroes) : _heroes;
    _equipments = _equipments.length === 0 ? transformArr(equipments) : _equipments;
    _consumables = _consumables.length === 0 ? transformArr(consumables) : _consumables;
    _dices = _dices.length === 0 ? transformArr(dices) : _dices;

    return [
        {
            accessorKey: 'halfwish_id',
            header: startCase('halfwish_id'),
        },
        {
            accessorKey: 'email',
            header: startCase('email'),
        },
        {
            accessorKey: 'hero',
            header: startCase('hero'),
        },
        {
            accessorKey: 'familiar',
            header: startCase('familiar'),
        },
        {
            accessorKey: 'gear',
            header: startCase('gear'),
        },
        {
            accessorKey: 'artifact',
            header: startCase('artifact'),
        },
        {
            accessorKey: 'hero_skin',
            header: startCase('hero_skin'),
        },
        {
            accessorKey: 'dice_skin',
            header: startCase('dice_skin'),
        },
        {
            accessorKey: 'card_skin',
            header: startCase('card_skin'),
        },
        {
            accessorKey: 'player_icons',
            header: startCase('player_icons'),
        },
        {
            accessorKey: 'emote',
            header: startCase('emote'),
        },
        {
            accessorKey: 'consumable',
            header: startCase('consumable'),
        },
        {
            accessorKey: 'item',
            header: startCase('item'),
        },
    ];
};

function transformArr(arr) {
    const newArr = arr?.map((item) => ({
        text: item.name,
        value: item.id,
    }));

    return newArr ?? [];
}
